import axios from "axios";
import {
    SET_SIMULATOR_LIST_REQUEST,
    SET_SIMULATOR_LIST_SUCCESS,
    SET_SIMULATOR_LIST_ERROR,
    SET_MODEL_LIST_REQUEST,
    SET_MODEL_LIST_SUCCESS,
    SET_MODEL_LIST_ERROR,
    SET_MODEL_VERSION_LIST_REQUEST,
    SET_MODEL_VERSION_LIST_SUCCESS,
    SET_MODEL_VERSION_LIST_ERROR,
    SET_FEATURE_LIST_REQUEST,
    SET_FEATURE_LIST_SUCCESS,
    SET_FEATURE_LIST_ERROR,
    SET_BASE_SCENARIO_LIST_REQUEST,
    SET_BASE_SCENARIO_LIST_SUCCESS,
    SET_BASE_SCENARIO_LIST_ERROR,
    SET_VARIATION_LIST_REQUEST,
    SET_VARIATION_LIST_SUCCESS,
    SET_VARIATION_LIST_ERROR,
    BASE_SCENARIO_SELECTED,
} from "../../../constants/closeLoop/scenarioCollection/dropDownModalConstants";

export const fetchSimulatorInfo = () => (dispatch) => {
    try {
        dispatch({ type: SET_SIMULATOR_LIST_REQUEST });
        axios({
            url: `/close_loop/fetch-simulator-data`,
            method: "GET",
        })
            .then((response) => {
                if (response && response.status === 200) {
                    // if (response.data.length !== 0) {
                    //     console.log("sim response", response);
                    // }
                    dispatch({
                        type: SET_SIMULATOR_LIST_SUCCESS,
                        simulatorListInfo: response.data,
                    });
                } else {
                    dispatch({
                        type: SET_SIMULATOR_LIST_ERROR,
                        payload: "Error occured while fetching the simulator list",
                    });
                }
            })
            .catch((error) => {
                // dispatch({
                //     type: SET_SIMULATOR_LIST_ERROR,
                //     payload: error.response.data.message,
                // });
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_SIMULATOR_LIST_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_SIMULATOR_LIST_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_SIMULATOR_LIST_ERROR, payload: errorMsg });
    }
};

export const fetchModelInfo = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_MODEL_LIST_REQUEST });
        axios({
            url: `/close_loop/fetch-model-data`,
            method: "POST",
            data: { simulator_name: payload },
        })
            .then((response) => {
                if (response && response.status === 200) {
                    // if (response.data.length !== 0) {
                    //     console.log("model response2", response);
                    // }
                    dispatch({
                        type: SET_MODEL_LIST_SUCCESS,
                        modelListInfo: response.data,
                    });
                } else {
                    dispatch({
                        type: SET_MODEL_LIST_ERROR,
                        payload: "Error occured while fetching the modal list",
                    });
                }
            })
            .catch((error) => {
                // dispatch({
                //     type: SET_MODEL_LIST_ERROR,
                //     payload: error.response.data.message,
                // });
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_MODEL_LIST_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_MODEL_LIST_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_MODEL_LIST_ERROR, payload: errorMsg });
    }
};

export const fetchModelVersionInfo = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_MODEL_VERSION_LIST_REQUEST });
        axios({
            url: `/close_loop/fetch-model-version`,
            method: "POST",
            data: { model_name: payload },
        })
            .then((response) => {
                if (response && response.status === 200) {
                    // if (response.data.length !== 0) {
                    //     console.log("model response2", response);
                    // }
                    dispatch({
                        type: SET_MODEL_VERSION_LIST_SUCCESS,
                        modelVersionListInfo: response.data,
                    });
                } else {
                    dispatch({
                        type: SET_MODEL_VERSION_LIST_ERROR,
                        payload: "Error occured while fetching the version list",
                    });
                }
            })
            .catch((error) => {
                // dispatch({
                //     type: SET_MODEL_VERSION_LIST_ERROR,
                //     payload: error.response.data.message,
                // });
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_MODEL_VERSION_LIST_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_MODEL_VERSION_LIST_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_MODEL_VERSION_LIST_ERROR, payload: errorMsg });
    }
};

export const fetchFeatureInfo = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_FEATURE_LIST_REQUEST });
        axios({
            url: `/close_loop/fetch-scenario-feature-data`,
            method: "POST",
            data: { model_name: payload },
        })
            .then((response) => {
                if (response && response.status === 200) {
                    // if (response.data.length !== 0) {
                    //     console.log("model response2", response);
                    // }
                    dispatch({
                        type: SET_FEATURE_LIST_SUCCESS,
                        featureListInfo: response.data,
                    });
                } else {
                    dispatch({
                        type: SET_FEATURE_LIST_ERROR,
                        payload: "Error occured while fetching the feature list",
                    });
                }
            })
            .catch((error) => {
                // dispatch({
                //     type: SET_FEATURE_LIST_ERROR,
                //     payload: error.response.data.message,
                // });
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_FEATURE_LIST_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_FEATURE_LIST_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_FEATURE_LIST_ERROR, payload: errorMsg });
    }
};

export const fetchBaseScenarioInfo = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_BASE_SCENARIO_LIST_REQUEST });
        axios({
            url: `/close_loop/fetch-base-scenario-data`,
            method: "POST",
            data: { scenario_feature_name: payload },
        })
            .then((response) => {
                if (response && response.status === 200) {
                    // if (response.data.length !== 0) {
                    //     console.log("model response2", response);
                    // }
                    dispatch({
                        type: SET_BASE_SCENARIO_LIST_SUCCESS,
                        baseScenarioListInfo: response.data,
                    });
                } else {
                    dispatch({
                        type: SET_BASE_SCENARIO_LIST_ERROR,
                        payload: "Error occured while fetching the base scenario list",
                    });
                }
            })
            .catch((error) => {
                // dispatch({
                //     type: SET_BASE_SCENARIO_LIST_ERROR,
                //     payload: error.response.data.message,
                // });
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_BASE_SCENARIO_LIST_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_BASE_SCENARIO_LIST_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_BASE_SCENARIO_LIST_ERROR, payload: errorMsg });
    }
};

export const fetchVariationListInfo = (payload, pageNum) => (dispatch) => {
    console.log("respose variation pageNum", pageNum);
    try {
        dispatch({ type: SET_VARIATION_LIST_REQUEST });
        axios({
            url: `/close_loop/fetch-scenario-variation-data`,
            method: "POST",
            data: { base_scenario_name: payload, page: pageNum },
        })
            .then((response) => {
                if (response && response.status === 200) {
                    // if (response.data.length !== 0) {
                    //     console.log("model response2", response);
                    // }
                    console.log("respose variation", response.data);
                    dispatch({
                        type: SET_VARIATION_LIST_SUCCESS,
                        variationListInfo: response.data,
                    });
                } else {
                    dispatch({
                        type: SET_VARIATION_LIST_ERROR,
                        payload: "Error occured while fetching the variation list",
                    });
                }
            })
            .catch((error) => {
                // dispatch({
                //     type: SET_VARIATION_LIST_ERROR,
                //     payload: error.response.data.message,
                // });
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_VARIATION_LIST_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_VARIATION_LIST_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_VARIATION_LIST_ERROR, payload: errorMsg });
    }
};

export const selectedBaseScenario = (baseScenarioSelected) => {
    return {
        type: BASE_SCENARIO_SELECTED,
        baseScenarioSelected: baseScenarioSelected,
    };
};
